import type { MutationTree } from "vuex";
import type { StatState, AlertEventStat } from "@/types";

export const LOAD_ALERT_EVENT = "LOAD_ALERT_EVENT";
export const LOAD_ALERT_EVENT_SUCCESS = "LOAD_ALERT_EVENT_SUCCESS";
export const LOAD_ALERT_EVENT_FAILURE = "LOAD_ALERT_EVENT_FAILURE";

export const mutations: MutationTree<StatState> = {
  // LOAD_ALERT_EVENT
  [LOAD_ALERT_EVENT](state: StatState) {
    state.alertEvent = { ...state.alertEvent, loading: true, error: null };
  },
  [LOAD_ALERT_EVENT_SUCCESS](
    state: StatState,
    alertEventStats: AlertEventStat[],
  ) {
    state.alertEvent = { data: alertEventStats, loading: false, error: null };
  },
  [LOAD_ALERT_EVENT_FAILURE](state: StatState, error: string) {
    state.alertEvent = { ...state.alertEvent, loading: false, error: error };
  },
};
